// extracted by mini-css-extract-plugin
module.exports = {"title":"interpretation-and-methodology-module__title___3eI-w","referenceList":"interpretation-and-methodology-module__referenceList___2sF5T"};